module.exports = __webpack_public_path__ + "static/26-slowthai-bb33bbf4bad6ac9a5e351d44531a0ff2.jpg";